import React, { Component } from 'react';
import { OrderStatus, ProductBrandTemplate, ProductCategory, RejectReasonJsonData } from '../infrastructure/AppConstants';
import authService from '../api-authorization/AuthorizeService'
import orderService from './OrderService';
import { FormattedMessage } from 'react-intl';
import { Pager } from '../controls/Pager'
import { DeleteButton } from '../controls/DeleteButton';
import { EditButton } from '../controls/EditButton';
import { CreateOrderButton } from './CreateOrderButton';
import { BaseTabControl } from '../controls/BaseTabControl';
import { ModalActionButton } from '../controls/ModalActionButton';
import toLocalString from '../infrastructure/DateTimeFunctions';
import InfoIdDialog from './InfoIdDialog'
import { AuthorityModules, AuthorityActions } from '../api-authorization/ApiAuthorizationConstants';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Toast from '../controls/BaseToast'
import ExcelUtil from '../utils/ExcelUtil';
import { ConfirmAlert } from '../controls/ConfirmAlert'
import { BaseCheckBox } from '../controls/BaseCheckBox';
import { SortIcon, SortUpIcon, SortDownIcon } from '../infrastructure/Icons';
import ReactToPrint from "react-to-print";
import { OrdersPreview } from './OrdersPreview';
import { PrinterIcon, SearchIcon, CheckCircleIcon, ArrowCircleUpIcon } from '@heroicons/react/solid';
import { RejectReasonsDialog } from './RejectReasonsDialog';
import { BaseCombobox } from '../controls/BaseCombobox';

export class Orders extends Component {
    static displayName = Orders.name;

    constructor(props) {
        super(props);
        let state = orderService.getOrdersState();

        if (state) {
            this.state = state;
            orderService.setOrdersState(null);
        }
        else {

            this.state = {
                printOrders: null, selectedOrderTemplate: -1, printPageStyle: "@page { size: landscape; margin:0px; }",
                orders: [], currentPage: 0, pageCount: 0, totalCount: 0, status: OrderStatus.Submitted, loading: true, open: false, isAllowConfirmOrder: false, orderNum: '', dealerName: '', brandId: '', customerName: '', productCategory: null, deliverAccountCode: '', orderStartTime: null, orderEndTime: null, products: [], confirmOpen: false, reviewId: null, sorts: { orderNumSort: 0, orderDateSort: 0, deliverAccountCodeSort: 0, dealerSort: 0, orderFinishStartTime: null, orderFinishEndTime: null,isOtherPlatform:false }
            };
        }
        this.data = RejectReasonJsonData;
        var categories = this.data.categories;
        this.state.categories = categories;
        this.state.selectedCategory = "-1";
        this.state.issues = [];
        this.state.selectedIssue = "-1";
        this.state.descriptions = [];
        this.state.selectedDesc = "-1";

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearching = this.handleSearching.bind(this);
        this.handleSearchDid = this.handleSearchDid.bind(this);
        this.handleDeleted = this.handleDeleted.bind(this);
        this.handleStatusChagned = this.handleStatusChagned.bind(this);
        this.openInfoIdDialog = this.openInfoIdDialog.bind(this);
        this.closeInfoIdDialog = this.closeInfoIdDialog.bind(this);
        this.populateListData = this.populateListData.bind(this);
        this.getProducts = this.getProducts.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.onReviewClose = this.onReviewClose.bind(this);
        this.onReviewOpen = this.onReviewOpen.bind(this);
        this.handleReview = this.handleReview.bind(this);
        this.handleCheckBoxAll = this.handleCheckBoxAll.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.handleColumnSort = this.handleColumnSort.bind(this);
        this.getNextSortStatus = this.getNextSortStatus.bind(this);
        this.handleOrderTemplateChanged = this.handleOrderTemplateChanged.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectIssueChange = this.handleSelectIssueChange.bind(this);
        this.handleSelectDescChange = this.handleSelectDescChange.bind(this);
        this.handleIsOtherPlatformChange = this.handleIsOtherPlatformChange.bind(this);

    }

    handleOrderTemplateChanged(e) {
        var value = parseInt(e.target.value)

        let printPage = value === 1 ? "@page { size: portrait; margin:0px; }" : "@page { size: landscape; margin:0px; }";

        this.setState({ selectedOrderTemplate: value, printPageStyle: printPage });
        this.populateListData();
    }

    openInfoIdDialog(e) {
        e.preventDefault();
        this.setState({ open: true });
    }
    closeInfoIdDialog() {
        this.setState({ open: false });
        this.populateListData();
    }
    handleIsOtherPlatformChange(e) {
        const target = e.target;
        const value = target.checked;
        const name = target.name;
        this.setState({
            [name]: value
        });
       // this.handleSearch();
    }
    async loadBatchPrintData(resolve) {
        let company = this.state.selectedOrderTemplate;
        let productCategory = this.state.productCategory;
        let status = this.state.status;
        if (company === -1 || company === '' || company === null || productCategory === '' || productCategory === null) {
            Toast.warn("CompanyAndOderTypeRequired");
            return;
        }
        var orders = this.state.orders.filter(x => x.checked);
        if (orders.length <= 0) {
            Toast.warn("SelectOnePrintOrder");
            return;
        }
        let ids = orders.map(x => { return x.id });
        //await orderService.GetWidexSeries();
        const data = await orderService.GetBatchPrintOrdersResult(true, ids, company, parseInt(productCategory), status); //TODO change args from UI
        this.setState({ printOrders: data }, () => resolve());
    }

    handleCheckBoxAll(e) {
        let checked = e.target.checked;
        var orders = this.state.orders;
        for (let i = 0; i < orders.length; i++) {
            orders[i].checked = checked;
        }
        this.setState({ orders: orders });
    }

    handleCheckBoxChange(e) {
        let checked = e.target.checked;
        let value = e.target.value;
        var orders = this.state.orders;
        for (let i = 0; i < orders.length; i++) {
            if (value === orders[i].id) {
                orders[i].checked = checked;
                break;
            }
        }
        this.setState({ orders: orders });



    }

    async handleExport(e) {
        const orderNum = this.state.orderNum;
        const dealerName = this.state.dealerName;
        //const brandName = this.state.brandName;
        const brandId = this.state.brandId;
        let brandName = "";
        if (brandId) {
            brandName = this.state.products.filter(x => x.id == brandId)[0].name;
        }
        const customerName = this.state.customerName;
        const productCategory = this.state.productCategory;
        const deliverAccountCode = this.state.deliverAccountCode;
        const orderStartTime = this.state.orderStartTime;
        const orderEndTime = this.state.orderEndTime;
        const orderTemplate = this.state.selectedOrderTemplate;
        const orderFinishStartTime = this.state.orderFinishStartTime;
        const orderFinishEndTime = this.state.orderFinishEndTime;
        const isOtherPlatform = this.state.isOtherPlatform;
        //if (brandName == "" || brandName == null) {
        //    Toast.warn("BrandRequired");
        //    return;
        //}

        if (productCategory == "" || productCategory == null) {
            Toast.warn("OderTypeRequired");
            return;
        }

        if (orderTemplate === -1) {
            Toast.warn("ComanyRequired");
            return;
        }


        const token = await authService.getAccessToken();
        const response = await fetch('order/ExportOrders', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'pageIndex': this.state.currentPage,
                'orderNum': orderNum,
                'dealerName': dealerName,
                'brandName': brandName,
                "brandId": brandId,
                'customerName': customerName,
                'productCategory': productCategory ? parseInt(productCategory) : null,
                'productBrandTemplate': (orderTemplate === -1) ? null : orderTemplate,
                'deliverAccountCode': deliverAccountCode,
                'orderStartTime': orderStartTime,
                'orderEndTime': orderEndTime,
                'status': this.state.status,
                "orderFinishStartTime": orderFinishStartTime,
                "orderFinishEndTime": orderFinishEndTime,
                "isOtherPlatform": isOtherPlatform
            })
        });
        let data = await response.json();
        if (data.length <= 0) {
            Toast.warn("NoEligibleData");
            return;
        }
        data = data.map(order => {
            return { ...order, orderTime: order.orderTime ? toLocalString(order.orderTime) : "", finishTime: order.finishTime ? toLocalString(order.finishTime) : "" }
        });

        let time = Date.now();
        let fileName = brandName + "_" + (productCategory === "1" ? "耳模" : "定制机") + "_" + time + ".xlsx";
        let headers;
        if (brandId == "9e9a666b2e0e475f8113a2f75c1d7010") //Workaround this should be a widex code
        {
            if (productCategory == 0) {
                headers =
                    [
                        {
                            title: '经销商',
                            dataIndex: 'dealerName',
                            key: 'dealerName',
                            className: 'text-monospace',
                        },
                        {
                            title: '品牌',
                            dataIndex: 'brandName',
                            key: 'brandName',
                        },
                        {
                            title: '订单类型',
                            dataIndex: 'productCategory',
                            key: 'productCategory',
                        },
                        {
                            title: '发货代码',
                            dataIndex: 'deliverAccountCode',
                            key: 'deliverAccountCode',
                        },
                        {
                            title: '客户姓名',
                            dataIndex: 'customerName',
                            key: 'customerName',
                        },
                        {
                            title: '当前机型品牌',
                            dataIndex: 'currentBrand',
                            key: 'currentBrand',
                        },
                        {
                            title: '当前机身型号',
                            dataIndex: 'machineBodyNumber',
                            key: 'machineBodyNumber',
                        },
                        {
                            title: '制作式样(左)',
                            dataIndex: 'lWidexMadeStyle',
                            key: 'lWidexMadeStyle',
                        },
                        {
                            title: '其他定制项(左)',
                            dataIndex: 'lWidexOtherMadeOptions',
                            key: 'lWidexOtherMadeOptions',
                        },
                        {
                            title: '通气孔类别(左)',
                            dataIndex: 'lWidexSpiracleType',
                            key: 'lWidexSpiracleType',
                        },
                        {
                            title: '耳道长度(左)',
                            dataIndex: 'lWidexAcousticMeatusSize',
                            key: 'lWidexAcousticMeatusSize',
                        },
                        {
                            title: '制作式样(右)',
                            dataIndex: 'rWidexMadeStyle',
                            key: 'rWidexMadeStyle',
                        },
                        {
                            title: '其他定制项(右)',
                            dataIndex: 'rWidexOtherMadeOptions',
                            key: 'rWidexOtherMadeOptions',
                        },
                        {
                            title: '通气孔类别(右)',
                            dataIndex: 'rWidexSpiracleType',
                            key: 'rWidexSpiracleType',
                        },
                        {
                            title: '耳道长度(右)',
                            dataIndex: 'rWidexAcousticMeatusSize',
                            key: 'rWidexAcousticMeatusSize',
                        },
                        {
                            title: '孔径大小',
                            dataIndex: 'widexSpiracleSize',
                            key: 'widexSpiracleSize',
                        }
                    ];
            }
            else {
                headers =
                    [
                        {
                            title: '经销商',
                            dataIndex: 'dealerName',
                            key: 'dealerName',
                            className: 'text-monospace',
                        },
                        {
                            title: '品牌',
                            dataIndex: 'brandName',
                            key: 'brandName',
                        },
                        {
                            title: '订单类型',
                            dataIndex: 'productCategory',
                            key: 'productCategory',
                        },
                        {
                            title: '发货代码',
                            dataIndex: 'deliverAccountCode',
                            key: 'deliverAccountCode',
                        },
                        {
                            title: '客户姓名',
                            dataIndex: 'customerName',
                            key: 'customerName',
                        },
                        {
                            title: '当前机型品牌',
                            dataIndex: 'currentBrand',
                            key: 'currentBrand',
                        },
                        {
                            title: '当前机身型号',
                            dataIndex: 'machineBodyNumber',
                            key: 'machineBodyNumber',
                        },
                        {
                            title: '常规耳背机耳模材料（左）',
                            dataIndex: 'lWidexBteEardrumMaterial',
                            key: 'lWidexBteEardrumMaterial',
                        },
                        {
                            title: '常规耳背机耳模式样（左）',
                            dataIndex: 'lWidexBteEardrumStyle',
                            key: 'lWidexBteEardrumStyle',
                        },
                        {
                            title: '细声管耳背机耳塞声管直径（左）',
                            dataIndex: 'lWidexBteEarphoneDiameter',
                            key: 'lWidexBteEarphoneDiameter',
                        },
                        {
                            title: '细声管耳背机耳塞式样（左）',
                            dataIndex: 'lWidexBteEarphoneStyle',
                            key: 'lWidexBteEarphoneStyle',
                        },

                        {
                            title: '外置受话器用定制耳塞材料（左）',
                            dataIndex: 'lWidexReceiverMaterial',
                            key: 'lWidexReceiverMaterial',
                        },
                        {
                            title: '外置受话器用定制耳塞式样（左）',
                            dataIndex: 'lWidexReceiverStyle',
                            key: 'lWidexReceiverStyle',
                        },
                        {
                            title: '外置受话器用定制耳塞受话器功率（左）',
                            dataIndex: 'lWidexReceiverPower',
                            key: 'lWidexReceiverPower',
                        },
                        {
                            title: '外置受话器用定制耳塞出声孔类别（左）',
                            dataIndex: 'lWidexSoundOutletType',
                            key: 'lWidexSoundOutletType',
                        },
                        {
                            title: '通气孔类别（左）',
                            dataIndex: 'lWidexSpiracleType',
                            key: 'lWidexSpiracleType',
                        },

                        {
                            title: '其他定制项（左）',
                            dataIndex: 'lWidexOtherMadeOptions',
                            key: 'lWidexOtherMadeOptions',
                        },
                        {
                            title: '常规耳背机耳模材料（右）',
                            dataIndex: 'rWidexBteEardrumMaterial',
                            key: 'rWidexBteEardrumMaterial',
                        },
                        {
                            title: '常规耳背机耳模式样（右）',
                            dataIndex: 'rWidexBteEardrumStyle',
                            key: 'rWidexBteEardrumStyle',
                        },
                        {
                            title: '细声管耳背机耳塞声管直径（右）',
                            dataIndex: 'rWidexBteEarphoneDiameter',
                            key: 'rWidexBteEarphoneDiameter',
                        },
                        {
                            title: '细声管耳背机耳塞式样（右）',
                            dataIndex: 'rWidexBteEarphoneStyle',
                            key: 'rWidexBteEarphoneStyle',
                        },

                        {
                            title: '外置受话器用定制耳塞材料（右）',
                            dataIndex: 'rWidexReceiverMaterial',
                            key: 'rWidexReceiverMaterial',
                        },
                        {
                            title: '外置受话器用定制耳塞式样（右）',
                            dataIndex: 'rWidexReceiverStyle',
                            key: 'rWidexReceiverStyle',
                        },
                        {
                            title: '外置受话器用定制耳塞受话器功率（右）',
                            dataIndex: 'rWidexReceiverPower',
                            key: 'rWidexReceiverPower',
                        },
                        {
                            title: '外置受话器用定制耳塞出声孔类别（右）',
                            dataIndex: 'rWidexSoundOutletType',
                            key: 'rWidexSoundOutletType',
                        },
                        {
                            title: '通气孔类别（右）',
                            dataIndex: 'rWidexSpiracleType',
                            key: 'rWidexSpiracleType',
                        },

                        {
                            title: '其他定制项（右）',
                            dataIndex: 'rWidexOtherMadeOptions',
                            key: 'rWidexOtherMadeOptions',
                        },

                        {
                            title: '孔径选择',
                            dataIndex: 'widexSpiracleSize',
                            key: 'widexSpiracleSize',
                        },
                        {
                            title: '外置受话器用定制耳塞耳钩线长度',
                            dataIndex: 'widexEarHookSize',
                            key: 'widexEarHookSize',
                        },
                        {
                            title: '细声管耳背机耳塞声管长度',
                            dataIndex: 'widexBteEarphoneSize',
                            key: 'widexBteEarphoneSize',
                        }
                    ];
            }
        }
        else {
            headers =
                [
                    {
                        title: '订单号',
                        dataIndex: 'orderNum',
                        key: 'orderNum',
                        className: 'text-monospace'
                    },
                    {
                        title: 'Infor订单号',
                        dataIndex: 'infoId',
                        key: 'infoId'
                    },
                    {
                        title: '订单日期',
                        dataIndex: 'orderTime',
                        key: 'orderTime'
                    },
                    {
                        title: '经销商',
                        dataIndex: 'dealerName',
                        key: 'dealerName'
                    },
                    {
                        title: '品牌',
                        dataIndex: 'brandName',
                        key: 'brandName'
                    },
                    {
                        title: '订单类型',
                        dataIndex: 'productCategory',
                        key: 'productCategory'
                },
                {
                    title: '是否听站用户',
                    dataIndex: 'isOtherPlatform',
                    key: 'isOtherPlatform'
                },
                    {
                        title: '发货代码',
                        dataIndex: 'deliverAccountCode',
                        key: 'deliverAccountCode'
                    },
                    {
                        title: '客户姓名',
                        dataIndex: 'customerName',
                        key: 'customerName'
                    },
                    {
                        title: '订单状态',
                        dataIndex: 'status',
                        key: 'status'
                    },
                    {
                        title: '完成日期',
                        dataIndex: 'finishTime',
                        key: 'finishTime'
                    }

                ];
            //if (productCategory == 0) {
            //    headers =
            //        [
            //            {
            //                title: '经销商',
            //                dataIndex: 'dealerName',
            //                key: 'dealerName',
            //                className: 'text-monospace',
            //            },
            //            {
            //                title: '品牌',
            //                dataIndex: 'brandName',
            //                key: 'brandName',
            //            },
            //            {
            //                title: '订单类型',
            //                dataIndex: 'productCategory',
            //                key: 'productCategory',
            //            },
            //            {
            //                title: '发货代码',
            //                dataIndex: 'deliverAccountCode',
            //                key: 'deliverAccountCode',
            //            },
            //            {
            //                title: '客户姓名',
            //                dataIndex: 'customerName',
            //                key: 'customerName',
            //            },
            //            {
            //                title: '是否老客户',
            //                dataIndex: 'isRegularCustomer',
            //                key: 'isRegularCustomer',
            //            },
            //            {
            //                title: '配戴助听器型号',
            //                dataIndex: 'currentBrand',
            //                key: 'currentBrand',
            //            },
            //            {
            //                title: '上次耳模编号',
            //                dataIndex: 'machineBodyNumber',
            //                key: 'machineBodyNumber',
            //            },
            //            {
            //                title: '左耳外壳',
            //                dataIndex: 'lEnclosureType',
            //                key: 'lEnclosureType',
            //            },
            //            {
            //                title: '是否有线(左)',
            //                dataIndex: 'lWireless',
            //                key: 'lWireless',
            //            },
            //            {
            //                title: '线路(左)',
            //                dataIndex: 'lLine',
            //                key: 'lLine',
            //            },
            //            {
            //                title: '规格(左)',
            //                dataIndex: 'lSpecMatrix',
            //                key: 'lSpecMatrix',
            //            },
            //            {
            //                title: 'Product Code(左)',
            //                dataIndex: 'lProductCode',
            //                key: 'lProductCode',
            //            },
            //            {
            //                title: 'RIC Code(左)',
            //                dataIndex: 'lRicCode',
            //                key: 'lRicCode',
            //            },
            //            {
            //                title: '右耳外壳',
            //                dataIndex: 'rEnclosureType',
            //                key: 'rEnclosureType',
            //            },
            //            {
            //                title: '是否有线(右)',
            //                dataIndex: 'rWireless',
            //                key: 'rWireless',
            //            },
            //            {
            //                title: '线路(右)',
            //                dataIndex: 'rLine',
            //                key: 'rLine',
            //            },
            //            {
            //                title: '规格(右)',
            //                dataIndex: 'rSpecMatrix',
            //                key: 'rSpecMatrix',
            //            },
            //            {
            //                title: 'Product Code(右)',
            //                dataIndex: 'rProductCode',
            //                key: 'rProductCode',
            //            },
            //            {
            //                title: 'RIC Code(右)',
            //                dataIndex: 'rRicCode',
            //                key: 'rRicCode',
            //            }
            //        ];
            //}
            //else {
            //    headers =
            //        [
            //            {
            //                title: '经销商',
            //                dataIndex: 'dealerName',
            //                key: 'dealerName',
            //                className: 'text-monospace',
            //            },
            //            {
            //                title: '品牌',
            //                dataIndex: 'brandName',
            //                key: 'brandName',
            //            },
            //            {
            //                title: '订单类型',
            //                dataIndex: 'productCategory',
            //                key: 'productCategory',
            //            },
            //            {
            //                title: '发货代码',
            //                dataIndex: 'deliverAccountCode',
            //                key: 'deliverAccountCode',
            //            },
            //            {
            //                title: '客户姓名',
            //                dataIndex: 'customerName',
            //                key: 'customerName',
            //            },
            //            {
            //                title: '是否老客户',
            //                dataIndex: 'isRegularCustomer',
            //                key: 'isRegularCustomer',
            //            },
            //            {
            //                title: '当前机型品牌',
            //                dataIndex: 'currentBrand',
            //                key: 'currentBrand',
            //            },
            //            {
            //                title: '当前机身型号',
            //                dataIndex: 'machineBodyNumber',
            //                key: 'machineBodyNumber',
            //            },
            //            {
            //                title: '左耳耳模选项',
            //                dataIndex: 'lEarmoldOption',
            //                key: 'lEarmoldOption',
            //            },
            //            {
            //                title: '样式(左)',
            //                dataIndex: 'lEarmoldType',
            //                key: 'lEarmoldType',
            //            },
            //            {
            //                title: '材质(左)',
            //                dataIndex: 'lEarmoldMaterial',
            //                key: 'lEarmoldMaterial',
            //            },
            //            {
            //                title: '颜色(左)',
            //                dataIndex: 'lEarmoldColor',
            //                key: 'lEarmoldColor',
            //            },
            //            {
            //                title: 'BTE通气孔(左)',
            //                dataIndex: 'lEardrumBteVent',
            //                key: 'lEardrumBteVent',
            //            },
            //            {
            //                title: 'BTE细声管3.0直径(左)',
            //                dataIndex: 'lEarmoldBteTubeDiameter',
            //                key: 'lEarmoldBteTubeDiameter',
            //            },
            //            {
            //                title: 'BTE细声管3.0长度(左)',
            //                dataIndex: 'lEarmoldBteTubeLength',
            //                key: 'lEarmoldBteTubeLength',
            //            },
            //            {
            //                title: 'BTE耳模3.0长度(左)',
            //                dataIndex: 'lEarmoldBteLength',
            //                key: 'lEarmoldBteLength',
            //            },
            //            {
            //                title: 'RIC受话器(左)',
            //                dataIndex: 'lEarmoldRicReceiverVersion',
            //                key: 'lEarmoldRicReceiverVersion',
            //            },
            //            {
            //                title: 'RIC通气孔(左)',
            //                dataIndex: 'lEardrumRicVent',
            //                key: 'lEardrumRicVent',
            //            },
            //            {
            //                title: 'RIC导线长度(左)',
            //                dataIndex: 'lEardrumRicCordLength',
            //                key: 'lEardrumRicCordLength',
            //            },
            //            {
            //                title: 'RIC拉线(左)',
            //                dataIndex: 'lEardrumRicCord',
            //                key: 'lEardrumRicCord',
            //            }
            //            ,
            //            {
            //                title: 'RIC受话器增益',
            //                dataIndex: 'lEardrumRicReceiver',
            //                key: 'lEardrumRicReceiver',
            //            },
            //            {
            //                title: '右耳耳模选项',
            //                dataIndex: 'rEarmoldOption',
            //                key: 'rEarmoldOption',
            //            },
            //            {
            //                title: '样式(右)',
            //                dataIndex: 'rEarmoldType',
            //                key: 'rEarmoldType',
            //            },
            //            {
            //                title: '材质(右)',
            //                dataIndex: 'rEarmoldMaterial',
            //                key: 'rEarmoldMaterial',
            //            },
            //            {
            //                title: '颜色(右)',
            //                dataIndex: 'rEarmoldColor',
            //                key: 'rEarmoldColor',
            //            },
            //            {
            //                title: 'BTE通气孔(右)',
            //                dataIndex: 'rEardrumBteVent',
            //                key: 'rEardrumBteVent',
            //            },
            //            {
            //                title: 'BTE细声管3.0直径(右)',
            //                dataIndex: 'rEarmoldBteTubeDiameter',
            //                key: 'rEarmoldBteTubeDiameter',
            //            },
            //            {
            //                title: 'BTE细声管3.0长度(右)',
            //                dataIndex: 'rEarmoldBteTubeLength',
            //                key: 'rEarmoldBteTubeLength',
            //            },
            //            {
            //                title: 'BTE耳模3.0长度(右)',
            //                dataIndex: 'rEarmoldBteLength',
            //                key: 'rEarmoldBteLength',
            //            },
            //            {
            //                title: 'RIC受话器(右)',
            //                dataIndex: 'rEarmoldRicReceiverVersion',
            //                key: 'rEarmoldRicReceiverVersion',
            //            },
            //            {
            //                title: 'RIC通气孔(右)',
            //                dataIndex: 'rEardrumRicVent',
            //                key: 'rEardrumRicVent',
            //            },
            //            {
            //                title: 'RIC导线长度(右)',
            //                dataIndex: 'rEardrumRicCordLength',
            //                key: 'rEardrumRicCordLength',
            //            },
            //            {
            //                title: 'RIC拉线(右)',
            //                dataIndex: 'rEardrumRicCord',
            //                key: 'rEardrumRicCord',
            //            }
            //            ,
            //            {
            //                title: 'RIC受话器增益(右)',
            //                dataIndex: 'rEardrumRicReceiver',
            //                key: 'rEardrumRicReceiver',
            //            }
            //        ];
            //}
        }

        ExcelUtil.ExportExcelWithStyle(headers, data, fileName);

    }
    onReviewClose() {
        this.setState({ confirmOpen: false, reviewId: null });
    }

    onReviewOpen(id, e) {
        e.preventDefault();
        this.setState({ confirmOpen: true, reviewId: id });
    }

    async handleReview(e) {
        var id = this.state.reviewId;
        const token = await authService.getAccessToken();
        const response = await fetch('order/AuditPass', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'id': id,
            })
        });
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    this.onReviewClose();
                    this.populateListData();
                }
                else {
                    Toast.warn(data.message);
                }
            }
        }
        else {
            console.error('response.status:' + response.status)
        }

    }

    componentWillUnmount() {
        orderService.setOrdersState(this.state);
    }

    async componentDidMount() {
        this.populateListData();
        const isAllow = await authService.isAllow(AuthorityModules.Order, AuthorityActions.ConfirmOrder);
        this.setState({
            isAllowConfirmOrder: isAllow
        });
        await this.getProducts();
    }

    async handleStatusChagned(item) {
        //  console.log("Selected status" + item);
        var index = OrderStatus[item];
        this.setState({ status: index });
        this.setState({ currentPage: 0 });
        await this.populateListData();
    }

    async handleDeleted(id) {
        if (id) {
            this.setState(
                {
                    orders: this.state.orders.filter((rec) => {
                        return (rec.id != id);
                    })
                });
        }
    }

    handleSearchDid(data) {
        this.setState({ orders: data.entities, pageCount: data.pageCount, totalCount: data.totalCount, loading: false });
    }

    handleSearching() {
        this.setState({ loading: true });
    }

    async handleSearch() {
        this.handleSearching();
        this.setState({ currentPage: 0 });
        await this.populateListData();

    }
    async getProducts() {
        const token = await authService.getAccessToken();
        const response = await fetch('product/GetProducts', {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        const data = await response.json();
        this.setState({ products: data });
    }
    async handlePageChange(index) {
        this.setState({ currentPage: index });
        await this.populateListData();
    }
    handleSelectDescChange(e) {
        var target = e.target;
        var value = target.value;
        this.setState({ selectedDesc: value });
    }
    handleSelectIssueChange(e) {
        var target = e.target;
        var value = target.value;
        var issues = this.state.issues;
        var descriptions = [];
        for (var i = 0; i < issues.length; i++) {
            if (value === issues[i].name) {
                descriptions = issues[i].descriptions;
                break;
            }
        }
        this.setState({ descriptions: descriptions, selectedDesc: "-1", selectedIssue: value });
    }

    handleSelectChange(e) {
        var target = e.target;
        var value = target.value;
        var categories = this.data.categories;
        var issues = [];
        var descriptions = [];
        for (var i = 0; i < categories.length; i++) {
            if (value === categories[i].name) {
                issues = categories[i].issues;
                descriptions = issues[0].descriptions;
                break;
            }
        }
        this.setState({ selectedCategory: value, issues: issues, selectedIssue: "-1", descriptions: descriptions, selectedDesc: "-1" });
    }

    onChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
        if (name == "productCategory") {
            this.populateListData();
        }
    }

    onOrderTimeChange = (item, e, name) => {
        this.setState({ [name]: item });
    }

    handleColumnSort(sortType) {
        var sortBy = OrderColumnSort.Default;
        switch (sortType) {
            case OrderColumnSort.DealerSortAsc:
                var status = this.getNextSortStatus(this.state.sorts.dealerSort);
                this.setState({ sorts: { orderNumSort: 0, orderDateSort: 0, deliverAccountCodeSort: 0, dealerSort: status } });
                if (status == 1) {
                    sortBy = OrderColumnSort.DealerSortAsc;
                } else if (status == 2) {
                    sortBy = OrderColumnSort.DealerSortDesc;
                }
                break;
            case OrderColumnSort.OrderDateSortAsc:
                var status = this.getNextSortStatus(this.state.sorts.orderDateSort);
                this.setState({ sorts: { orderNumSort: 0, orderDateSort: status, deliverAccountCodeSort: 0, dealerSort: 0 } });
                if (status == 1) {
                    sortBy = OrderColumnSort.OrderDateSortAsc;
                } else if (status == 2) {
                    sortBy = OrderColumnSort.OrderDateSortDesc;
                }
                break;
            case OrderColumnSort.DeliverAccountCodeSortAsc:
                var status = this.getNextSortStatus(this.state.sorts.deliverAccountCodeSort);
                this.setState({ sorts: { orderNumSort: 0, orderDateSort: 0, deliverAccountCodeSort: status, dealerSort: 0 } });
                if (status == 1) {
                    sortBy = OrderColumnSort.DeliverAccountCodeSortAsc;
                } else if (status == 2) {
                    sortBy = OrderColumnSort.DeliverAccountCodeSortDesc;
                }
                break;
            case OrderColumnSort.OrderNumSortAsc:
                var status = this.getNextSortStatus(this.state.sorts.orderNumSort);
                this.setState({ sorts: { orderNumSort: status, orderDateSort: 0, deliverAccountCodeSort: 0, dealerSort: 0 } });
                if (status == 1) {
                    sortBy = OrderColumnSort.OrderNumSortAsc;
                } else if (status == 2) {
                    sortBy = OrderColumnSort.OrderNumSortDesc;
                }
                break;
            default:
                break;
        }
        this.populateListData(sortBy);
    }
    getNextSortStatus(currentStatus) {
        var status = [0, 1, 2];
        var index = status.indexOf(currentStatus);
        if (index == status.length - 1) {
            return status[0];
        }
        return status[index + 1]
    }
    renderStatus(orderStatus) {
        if (this.state.status == OrderStatus.All) {
            var display = '';
            switch (orderStatus) {
                case OrderStatus.Draft:
                    display = 'Draft';
                    return <span className="px-2 py-1 font-semibold leading-tight text-yellow-700 bg-yellow-100 rounded-full dark:bg-yellow-700 dark:text-yellow-100"> <FormattedMessage id={display} /></span>
                case OrderStatus.DealerReview:
                    display = 'DealerReview';
                    return <span className="px-2 py-1 font-semibold leading-tight text-yellow-700 bg-yellow-100 rounded-full dark:bg-yellow-700 dark:text-yellow-100"> <FormattedMessage id={display} /></span>
                case OrderStatus.Submitted:
                    display = 'Submitted';
                    return <span className="px-2 py-1 font-semibold leading-tight text-blue-700 bg-blue-100 rounded-full dark:bg-blue-700 dark:text-blue-100"> <FormattedMessage id={display} /></span>
                case OrderStatus.Reviewed:
                    display = 'Reviewed';
                    return <span className="px-2 py-1 font-semibold leading-tight text-indigo-700 bg-indigo-100 rounded-full dark:bg-indigo-700 dark:text-indigo-100"> <FormattedMessage id={display} /></span>
                case OrderStatus.Retreat:
                    display = 'Retreat';
                    return <span className="px-2 py-1 font-semibold leading-tight text-red-700 bg-red-100 rounded-full dark:bg-red-700 dark:text-red-100"> <FormattedMessage id={display} /></span>
                case OrderStatus.Finish:
                    display = 'Finish';
                    return <span className="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-green-100"> <FormattedMessage id={display} /></span>
                case OrderStatus.Cancel:
                    display = 'Cancel';
                    return <span className="px-2 py-1 font-semibold leading-tight text-red-700 bg-red-300 rounded-full dark:bg-red-700 dark:text-red-100"> <FormattedMessage id={display} /></span>

            }

            return <FormattedMessage id={display} />
        }

        return ('');
    }

    rendActions(a) {
        switch (a.status) {
            case OrderStatus.Draft:
            case OrderStatus.DealerReview:
                return (<div className="flex flex-row">
                    <EditButton module={AuthorityModules.Order} action={AuthorityActions.Edit} url={'/order/EditOrder/' + a.id} />
                    |<DeleteButton module={AuthorityModules.Order} action={AuthorityActions.Delete} url="order/delete/" id={a.id} onDeleteExecuted={this.handleDeleted} />
                </div>);
            case OrderStatus.Submitted:
                return (<div className="flex flex-row">
                    <EditButton displayname="View" module={AuthorityModules.Order} action={AuthorityActions.View} url={'/order/EditOrder/' + a.id} />
                    {/* {(this.state.isAllowConfirmOrder && (<span>|<a href="#" className="text-indigo-600 hover:text-indigo-900" onClick={(e) => this.onReviewOpen(a.id, e)}><FormattedMessage id="ConfirmOrder" /></a></span>))}*/}
                </div>);
            case OrderStatus.Reviewed:
                return (<div className="flex flex-row">
                    <EditButton displayname="View" module={AuthorityModules.Order} action={AuthorityActions.View} url={'/order/EditOrder/' + a.id} />
                    {/*  {(this.state.isAllowConfirmOrder && (<span>|<a href="#" className="text-indigo-600 hover:text-indigo-900" onClick={(e) => this.openInfoIdDialog(a.id, e)}><FormattedMessage id="FinishOrder" /></a></span>))}*/}
                </div>);
            case OrderStatus.Retreat:
                return (<div className="flex flex-row">
                    <EditButton module={AuthorityModules.Order} action={AuthorityActions.Edit} url={'/order/EditOrder/' + a.id} />|
                    <DeleteButton module={AuthorityModules.Order} action={AuthorityActions.Delete} url="order/delete/" id={a.id} onDeleteExecuted={this.handleDeleted} />
                </div>);
            case OrderStatus.Finish:
                return (<div className="flex flex-row">
                    <EditButton displayname="View" module={AuthorityModules.Order} action={AuthorityActions.View} url={'/order/EditOrder/' + a.id} />
                </div>);
            case OrderStatus.Cancel:
                return (<div className="flex flex-row">
                    <EditButton displayname="View" module={AuthorityModules.Order} action={AuthorityActions.View} url={'/order/EditOrder/' + a.id} />
                </div>);
        }

        return (<div className="flex flex-row">
            <EditButton module={AuthorityModules.Order} action={AuthorityActions.Edit} url={'/order/EditOrder/' + a.id} />|
            <DeleteButton module={AuthorityModules.Order} action={AuthorityActions.Delete} url="order/delete/" id={a.id} onDeleteExecuted={this.handleDeleted} />
        </div>);
    }

    static toColumnSort(sort) {
        if (sort == 0) {
            return (<SortIcon className="w-4 h-4 text-gray-400" />);
        } else if (sort == 1) {
            return (<SortUpIcon className="w-4 h-4 text-gray-400" />);
        } else {
            return (<SortDownIcon className="w-4 h-4 text-gray-400" />);
        }
    }
    renderForecastsTable(orders, handleEdit, handleDeleted, sorts, handleColumnSort) {
        //console.log(orders);
        return (
            <div className="w-full overflow-x-auto">
                <table className="w-full text-xs">
                    <thead>
                        <tr className="font-semibold tracking-wide text-left text-gray-500 border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                            {this.state.isAllowConfirmOrder && (this.state.status == OrderStatus.Submitted || this.state.status == OrderStatus.Reviewed) && <th className="text-center" style={{ minWidth: 40 }}><BaseCheckBox name="checkAll" onChange={this.handleCheckBoxAll} /></th>}
                            <th className="px-4 py-3" style={{ minWidth: 90 }} >
                                <label className="flex cursor-pointer" onClick={(e) => handleColumnSort(OrderColumnSort.OrderNumSortAsc)} ><FormattedMessage id="OrderNum" />{Orders.toColumnSort(sorts.orderNumSort)}</label>
                            </th>
                            <th className="px-4 py-3" style={{ minWidth: 110 }}><FormattedMessage id="InfoOrderNum" /></th>
                            <th className="px-2 py-1" style={{ minWidth: 90 }}>
                                <label className="flex cursor-pointer" onClick={(e) => handleColumnSort(OrderColumnSort.OrderDateSortAsc)}><FormattedMessage id="OrderTime" />{Orders.toColumnSort(sorts.orderDateSort)}</label>
                            </th>
                            <th className="px-4 py-3" style={{ minWidth: 110 }}>
                                <label className="flex cursor-pointer" onClick={(e) => handleColumnSort(OrderColumnSort.DealerSortAsc)}><FormattedMessage id="DealerName" />{Orders.toColumnSort(sorts.dealerSort)}</label>
                            </th>
                            <th className="px-4 py-3" style={{ minWidth: 60 }}><FormattedMessage id="IsTingzhanUser" /></th>
                            <th className="px-4 py-3" style={{ minWidth: 60 }}><FormattedMessage id="Brand" /></th>
                            <th className="px-4 py-3" style={{ minWidth: 130 }}>
                                <label className="flex cursor-pointer" onClick={(e) => handleColumnSort(OrderColumnSort.DeliverAccountCodeSortAsc)}><FormattedMessage id="DeliverAccountCode" />{Orders.toColumnSort(sorts.deliverAccountCodeSort)}</label>
                            </th>
                            <th className="px-4 py-3" style={{ minWidth: 90 }}><FormattedMessage id="ProductCategory" /></th>
                            <th className="px-4 py-3" style={{ minWidth: 90 }}><FormattedMessage id="CustomerName" /></th>
                            <th className="px-4 py-3" style={{ minWidth: 110 }}><FormattedMessage id="RejectHistory" /></th>
                            <th className="px-4 py-3" style={{ minWidth: 90 }}><FormattedMessage id="FinishTime" /></th>
                            {this.state.status == OrderStatus.All && <th className="px-4 py-3" style={{ minWidth: 90 }}><FormattedMessage id="Status" /></th>}
                            <th className="px-4 py-3" style={{ minWidth: 100 }}><FormattedMessage id="Actions" /></th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-sm">
                        {
                            orders.map(a =>
                                <tr key={a.id} className="bg-gra-50 hover:bg-gray-100 text-gray-700 dark:text-gray-400">
                                    {this.state.isAllowConfirmOrder && (this.state.status == OrderStatus.Submitted || this.state.status == OrderStatus.Reviewed) && <td className="text-center"><BaseCheckBox value={a.id} onChange={this.handleCheckBoxChange} checked={a.checked} /></td>}
                                    <td className="px-3 py-1 2xl:py-2"><p className="font-semibold">{a.orderNum}</p></td>
                                    <td className="px-3 py-1 2xl:py-2">{a.infoId}</td>
                                    <td className="px-3 py-1 2xl:py-2">{a.orderTime ? toLocalString(a.orderTime) : ""}</td>
                                    <td className="px-4 py-1 2xl:py-2">{a.dealerName}</td>
                                    <td className="px-3 py-1 2xl:py-2"><FormattedMessage id={a.isOtherPlatform? "Yes" : "No"} /></td>
                                    <td className="px-3 py-1 2xl:py-2">{a.brandName}</td>
                                    <td className="px-3 py-1 2xl:py-2">{a.deliverAccountCode}</td>
                                    <td className="px-3 py-1 2xl:py-2"><FormattedMessage id={a.productCategory == 1 ? "Eardrum" : "CustomMade"} /></td>
                                    <td className="px-3 py-1 2xl:py-2">{a.customerName}</td>
                                    <td className="px-3 py-1 2xl:py-2">{a.rejectReasons && a.rejectReasons.length > 0 && <RejectReasonsDialog reasons={a.rejectReasons} />}</td>
                                    <td className="px-3 py-1 2xl:py-2">{a.finishTime ? toLocalString(a.finishTime) : ""}</td>
                                    {this.state.status == OrderStatus.All && <td>{this.renderStatus(a.status)}</td>}
                                    <td className="px-3 py-1 2xl:py-2">
                                        {this.rendActions(a)}
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        let status = "";
        switch (this.state.status) {
            case OrderStatus.All:
                status = "All";
                break;
            case OrderStatus.Draft:
                status = "Draft";
                break;
            case OrderStatus.DealerReview:
                status = "DealerReview";
                break;
            case OrderStatus.Submitted:
                status = "Submitted";
                break;
            case OrderStatus.Retreat:
                status = "Retreat";
                break;
            case OrderStatus.Reviewed:
                status = "Reviewed";
                break;
            case OrderStatus.Finish:
                status = "Finish";
                break;
            case OrderStatus.Cancel:
                status = "Cancel";
                break;
        }
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderForecastsTable(this.state.orders, this.handleEdit, this.handleDeleted, this.state.sorts, this.handleColumnSort);
        return (
            <div className="mt-4 mx-4">
                <div className="shadow overflow-hidden sm:rounded-md mb-2">
                    <div className="flex justify-between px-4 py-4 bg-white">
                        <div className="flex-grow grid grid-cols-5 gap-x-3 gap-y-2 mr-4">
                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="OrderNumOrInfNo" /></label>
                                <input type="text" onChange={this.onChange} name="orderNum"
                                    value={this.state.orderNum}
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>
                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="DealerName" /></label>
                                <input type="text" onChange={this.onChange} name="dealerName"
                                    value={this.state.dealerName}
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>
                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="DeliverAccountCode" /></label>
                                <input type="text" onChange={this.onChange} name="deliverAccountCode"
                                    value={this.state.deliverAccountCode}
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>

                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="OrderStartTime" /></label>
                                <DatePicker name="orderStartTime" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    //  onSelect={handleDateSelect} //when day is clicked
                                    onChange={(item, e) => { this.onOrderTimeChange(item, e, "orderStartTime") }} //only when value has changed
                                    selected={this.state.orderStartTime}
                                    dateFormat="yyyy-MM-dd"
                                />
                            </div>

                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="OrderEndTime" /></label>
                                <DatePicker name="orderEndTime" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    //  onSelect={handleDateSelect} //when day is clicked
                                    onChange={(item, e) => { this.onOrderTimeChange(item, e, "orderEndTime") }} //only when value has changed
                                    selected={this.state.orderEndTime}
                                    dateFormat="yyyy-MM-dd"
                                />
                            </div>

                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="RejectReasonCategory1" /></label>
                                <BaseCombobox onChange={this.handleSelectChange} value={this.state.selectedCategory}>
                                    <FormattedMessage id="PickOne">
                                        {value => <option key="-1" value="-1">{value}</option>}
                                    </FormattedMessage>
                                    {this.state.categories.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}

                                </BaseCombobox>
                            </div>
                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="RejectReasonIssue" /></label>
                                <BaseCombobox onChange={this.handleSelectIssueChange} value={this.state.selectedIssue} >
                                    <FormattedMessage id="PickOne">
                                        {value => <option value="-1">{value}</option>}
                                    </FormattedMessage>
                                    {this.state.issues.map(i => <option value={i.name}>{i.name}</option>)}
                                </BaseCombobox>
                            </div>
                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="RejectReasonDescription" /></label>
                                <BaseCombobox onChange={this.handleSelectDescChange} value={this.state.selectedDesc} >
                                    <FormattedMessage id="PickOne">
                                        {value => <option value="-1">{value}</option>}
                                    </FormattedMessage>
                                    {this.state.descriptions && this.state.descriptions.map(i => <option value={i}>{i}</option>)}

                                </BaseCombobox>
                            </div>

                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="OrderFinishStartTime" /></label>
                                <DatePicker name="orderFinishStartTime" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    //  onSelect={handleDateSelect} //when day is clicked
                                    onChange={(item, e) => { this.onOrderTimeChange(item, e, "orderFinishStartTime") }} //only when value has changed
                                    selected={this.state.orderFinishStartTime}
                                    dateFormat="yyyy-MM-dd"
                                />
                            </div>

                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="OrderFinishEndTime" /></label>
                                <DatePicker name="orderFinishEndTime" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    //  onSelect={handleDateSelect} //when day is clicked
                                    onChange={(item, e) => { this.onOrderTimeChange(item, e, "orderFinishEndTime") }} //only when value has changed
                                    selected={this.state.orderFinishEndTime}
                                    dateFormat="yyyy-MM-dd"
                                />
                            </div>

                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="CustomerName" /></label>
                                <input type="text" onChange={this.onChange} name="customerName"
                                    value={this.state.customerName}
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            </div>
                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Brand" /></label>
                                <select name="brandId" onChange={this.onChange}
                                    value={this.state.brandId}
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" >
                                    <FormattedMessage id="PickOne">
                                        {value => <option value="">{value}</option>}
                                    </FormattedMessage>
                                    {this.state.products.map((item, index) => {
                                        return (
                                            <option value={item.id} key={index}>{item.name}</option>
                                        )
                                    })}

                                </select>
                            </div>
                            <div className="">
                                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="ProductCategory" /></label>
                                <select name="productCategory" onChange={this.onChange}
                                    value={this.state.productCategory}
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" >
                                    <FormattedMessage id="PickOne">
                                        {value => <option value="">{value}</option>}
                                    </FormattedMessage>
                                    <FormattedMessage id="CustomMade">
                                        {value => <option value="0">{value}</option>}
                                    </FormattedMessage>
                                    <FormattedMessage id="Eardrum">
                                        {value => <option value="1">{value}</option>}
                                    </FormattedMessage>
                                </select>
                            </div>

                            <div>
                                <div className="grid grid-cols-3">
                                    <div className="col-span-2">
                                        <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Company" /></label>
                                        <select onChange={this.handleOrderTemplateChanged}
                                            value={this.state.selectedOrderTemplate}
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" >>
                                            <FormattedMessage id="PickOne">
                                                {value => <option value="-1" >{value}</option>}
                                            </FormattedMessage>
                                            <FormattedMessage id="WSA">
                                                {text => <option value="0" >{text}</option>}
                                            </FormattedMessage>
                                            <FormattedMessage id="Widex">
                                                {text => <option value="1" >{text}</option>}
                                            </FormattedMessage>
                                        </select>
                                    </div>
                                    <div className="col-span-1 grid grid-rows-2  place-items-center">
                                        <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="OnlyTingzhan" /></label>
                                        <BaseCheckBox type="checkbox" name="isOtherPlatform" checked={this.state.isOtherPlatform ? "checked" : ""} onChange={this.handleIsOtherPlatformChange}></BaseCheckBox>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-end justify-start pb-1">
                                <span className="hidden sm:block flex-shrink-0">
                                    <button className="hover:bg-blue-500 hover:text-blue-800 group flex items-center rounded-md bg-blue-600 text-white text-sm font-medium px-4 py-2 mr-1" onClick={this.handleSearch}>
                                        <SearchIcon className="-ml-1 mr-2 h-5 w-5 text-white" aria-hidden="true" /><FormattedMessage id="Search" /></button>
                                </span>
                                <span className="hidden sm:block flex-shrink-0 -mr-1">
                                    <ModalActionButton className="border border-blue-400 rounded-sm bg-blue-300" displayName="Export" desc="ExportingData"
                                        actionAsnc={this.handleExport} buttonIcon={() => <ArrowCircleUpIcon className="-ml-1 mr-1 h-5 w-5 text-white" aria-hidden="true" />} />
                                </span>
                                <span className="hidden sm:block flex-shrink-0">
                                    <CreateOrderButton module={AuthorityModules.Order} action={AuthorityActions.Create} history={this.props.history} />
                                </span>
                            </div>

                        </div>

                    </div>
                </div>
                <div className='flex justify-between'>
                    <BaseTabControl items={["Draft", "DealerReview", "Submitted", "Reviewed", "Retreat", "Finish", "Cancel", "All"]} defaultItem={status} onTabItemChanged={this.handleStatusChagned} populateListData={this.populateListData} />
                    <div className="mt-5 flex lg:mt-0 lg:ml-4 items-center gap-x-1">
                        <span className="hidden sm:block">
                            {this.state.isAllowConfirmOrder && this.state.status == OrderStatus.Reviewed && <button name="FinishOrder" onClick={this.openInfoIdDialog}
                                className="inline-flex items-center px-4 py-2 border border-blue-300 rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            ><CheckCircleIcon className="-ml-1 mr-2 h-5 w-5 text-white" aria-hidden="true" /><FormattedMessage id="FinishOrder" /></button>}
                        </span>
                        <InfoIdDialog onRef={(ref) => { this.infoIdDialog = ref }} open={this.state.open} onClose={this.closeInfoIdDialog} />
                        {this.state.isAllowConfirmOrder && (this.state.status == OrderStatus.Submitted || this.state.status == OrderStatus.Reviewed) && <ReactToPrint
                            trigger={() => <span className="hidden sm:block"><button name="Print"
                                className="inline-flex items-center px-4 py-2 border border-blue-300 rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            ><PrinterIcon className="-ml-1 mr-2 h-5 w-5 text-white" aria-hidden="true" /><FormattedMessage id="Print" /></button></span>}
                            content={() => this.componentRef}
                            onBeforeGetContent={() => {
                                return new Promise((resolve, reject) => {
                                    this.loadBatchPrintData(() => resolve());
                                });
                            }}
                            onAfterPrint={() => {
                                this.populateListData();
                                return new Promise((resolve, reject) => {
                                    this.setState({ printOrders: null }, () => resolve());
                                });
                            }}
                            pageStyle={this.state.printPageStyle}
                        />}
                    </div>
                </div>
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    {contents}
                    <Pager currentPage={this.state.currentPage} pageCount={this.state.pageCount} totalCount={this.state.totalCount} onPageChange={this.handlePageChange} />
                </div>
                {/*  <InfoIdDialog onRef={(ref) => { this.infoIdDialog = ref }} open={this.state.open} onClose={this.closeInfoIdDialog} callback={this.populateListData} />*/}
                <ConfirmAlert onRef={(ref) => { this.confirmRef = ref }} onCancel={this.onReviewClose} onOk={(e) => { this.handleReview(e) }} open={this.state.confirmOpen} messageId="AuditPass" />
                <div ref={(el) => (this.componentRef = el)} id="impagePreview">
                    {(this.state.printOrders && this.state.printOrders.orders.length > 0) ? <OrdersPreview id="ordersPreview" data={this.state.printOrders} /> : null}
                </div>
            </div>
        );
    }

    async populateListData(sortBy) {
        const token = await authService.getAccessToken();
        const orderNum = this.state.orderNum;
        const dealerName = this.state.dealerName;
        //  const brandName = this.state.brandName;
        const brandId = this.state.brandId;
        let brandName = "";
        if (brandId) {
            brandName = this.state.products.filter(x => x.id == brandId)[0].name;
        }
        const customerName = this.state.customerName;
        const productCategory = this.state.productCategory;
        const deliverAccountCode = this.state.deliverAccountCode;
        const orderStartTime = this.state.orderStartTime;
        const orderEndTime = this.state.orderEndTime;
        const orderTemplate = this.state.selectedOrderTemplate;
        const selectedCategory = this.state.selectedCategory;
        const selectedIssue = this.state.selectedIssue;
        const selectedDesc = this.state.selectedDesc;
        const orderFinishStartTime = this.state.orderFinishStartTime;
        const orderFinishEndTime = this.state.orderFinishEndTime;
        const isOtherPlatform = this.state.isOtherPlatform;

        const response = await fetch('order/GetOrders', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'pageIndex': this.state.currentPage,
                'orderNum': orderNum,
                'dealerName': dealerName,
                'brandName': brandName,
                "brandId": brandId,
                'customerName': customerName,
                'productCategory': productCategory ? parseInt(productCategory) : null,
                'deliverAccountCode': deliverAccountCode,
                'orderStartTime': orderStartTime,
                'orderEndTime': orderEndTime,
                'productBrandTemplate': (orderTemplate === -1) ? null : orderTemplate,
                "status": this.state.status,
                "orderSort": sortBy,
                "rejectReasonCategory": selectedCategory == "-1" ? null : selectedCategory,
                "rejectReasonIssue": selectedIssue == "-1" ? null : selectedIssue,
                "rejectReasonDesc": selectedDesc == "-1" ? null : selectedDesc,
                "orderFinishStartTime": orderFinishStartTime,
                "orderFinishEndTime": orderFinishEndTime,
                "isOtherPlatform": isOtherPlatform
            })
        });
        const data = await response.json();
        // await orderService.loadEarmoldOptionSettings();
        this.setState({ orders: data.entities, pageCount: data.pageCount, totalCount: data.totalCount, loading: false });
    }

}
export const OrderColumnSort = {
    Default: 0,
    OrderNumSortAsc: 1,
    OrderNumSortDesc: 2,
    OrderDateSortAsc: 3,
    OrderDateSortDesc: 4,
    DeliverAccountCodeSortAsc: 5,
    DeliverAccountCodeSortDesc: 6,
    DealerSortAsc: 7,
    DealerSortDesc: 8
}

